import { apiClient } from '../api/apiClient';
import { apiEndpoints } from '../api/apiEndpoints';

type HealthApiResponse = {
  success?: boolean;
  message?: string;
  requestId?: string;
  data?: unknown;
};
export type HealthResult = {
  healthy: boolean;
  message: string;
  requestId?: string | null;
  data?: unknown;
};

export async function getHealth(): Promise<HealthResult> {
  const response = await apiClient.get<HealthApiResponse>(apiEndpoints.health);
  const requestId =
    response.data.requestId ?? response.headers['x-request-id'] ?? null;
  return {
    healthy: response.data.success === true,
    message: response.data.message || 'Health status received.',
    requestId,
    data: response.data.data,
  };
}
